import { useRef } from 'react';
import { LABEL_EXAMPLES, type LabelExample } from '../examples';

export default function Examples() {
  return (
    <div className="card">
      <h2>標註範例</h2>
      <p className="muted">
        以下為標註範例。影片載入後會自動跳至已標註的時間點並暫停，可作為「停止線通過時刻」的對照參考。
      </p>
      <div className="examples-grid">
        {LABEL_EXAMPLES.map(ex => (
          <ExampleCard key={ex.event_id} example={ex} />
        ))}
      </div>
    </div>
  );
}

function ExampleCard({ example }: { example: LabelExample }) {
  const ref = useRef<HTMLVideoElement>(null);

  function onLoadedMetadata() {
    const v = ref.current;
    if (!v) return;
    v.currentTime = example.time_seconds;
    v.pause();
  }

  function replay() {
    const v = ref.current;
    if (!v) return;
    // 從標註點往前 1.5 秒開始重播，方便觀察通過瞬間
    v.currentTime = Math.max(0, example.time_seconds - 1.5);
    v.play();
  }

  function resetToLabel() {
    const v = ref.current;
    if (!v) return;
    v.currentTime = example.time_seconds;
    v.pause();
  }

  return (
    <div className="example-card">
      <video
        ref={ref}
        src={example.video_url}
        muted
        playsInline
        controls
        preload="metadata"
        onLoadedMetadata={onLoadedMetadata}
      />
      <div className="example-meta">
        <span>事件 ID：<b>{example.event_id}</b></span>
        <span>標註時間：<b>{example.time_seconds.toFixed(3)} 秒</b></span>
        <span className="muted">影片時長 {example.video_duration.toFixed(2)} 秒</span>
      </div>
      <div className="example-actions">
        <button type="button" onClick={resetToLabel}>跳至標註點</button>
        <button type="button" onClick={replay}>從前 1.5 秒重播</button>
      </div>
    </div>
  );
}
